module.exports = __webpack_public_path__ + "static/media/Lottery.5e0db917.svg";